'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["iconSize", "size", "semanticColor", "color", "title", "titleId", "desc", "descId", "autoMirror", "width", "height", "aria-label"];
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { Svg } from "./Svg.mjs";
export var IconSizeMap = {
  xsmall: 12,
  small: 16,
  medium: 24,
  large: 32,
  xlarge: 48,
  xxlarge: 64
};
var getIconSizeKey = function getIconSizeKey(iconSize) {
  return Object.keys(IconSizeMap).find(function (key) {
    return IconSizeMap[key] === iconSize;
  });
};

// return the highest possible size that is <= the requested size,
// we sort asc to return the smallest size if requested value < smallest size
export var findClosestGlyphAvailable = function findClosestGlyphAvailable(glyphList, val) {
  return glyphList.sort(function (a, b) {
    return a.size - b.size;
  }).reduce(function (prev, current) {
    if (current.size <= val && current.size > prev.size) {
      return current;
    }
    return prev;
  });
};
function getTokenType(attrs) {
  var hasAssistiveText = Object.values(attrs).some(function (attr) {
    return attr;
  });
  return hasAssistiveText ? 'informative' : 'decorative';
}
export var Icon = function Icon(_ref) {
  var iconSize = _ref.iconSize,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    semanticColor = _ref.semanticColor,
    color = _ref.color,
    title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    autoMirror = _ref.autoMirror,
    width = _ref.width,
    height = _ref.height,
    ariaLabel = _ref['aria-label'],
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Svg, Object.assign({
    "data-encore-id": ENCORE_DATA_IDS.Icon,
    role: "img",
    "aria-label": ariaLabel,
    "aria-labelledby": title && titleId ? titleId : props['aria-labelledby'],
    "aria-describedby": desc && descId ? descId : props['aria-describedby'],
    "aria-hidden": !title && !titleId,
    $size: iconSize ? getIconSizeKey(iconSize) : size,
    $iconColor: semanticColor,
    $autoMirror: autoMirror,
    $width: width,
    $height: height,
    $tokenType: getTokenType({
      ariaLabel: ariaLabel,
      title: title,
      desc: desc
    })
  }, props));
};